import {SequenceState} from '../sequence';
import {BasicFilters} from './basic-filters';

export class SequenceFilters extends BasicFilters {
  organizationUuids: string[];
  state: SequenceState;

  constructor() {
    super();
    this.state = null;
  }
}
